import { render } from "./PaymentRequestSAPList.vue?vue&type=template&id=2709be5a&scoped=true"
import script from "./PaymentRequestSAPList.vue?vue&type=script&lang=ts"
export * from "./PaymentRequestSAPList.vue?vue&type=script&lang=ts"

import "./PaymentRequestSAPList.vue?vue&type=style&index=0&id=2709be5a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2709be5a"

export default script